import ResignationDetails from "../../../components/company/workforce/resigned/resignation-details";

export default function EmployeeResignationPage() {
  return <ResignationDetails />;
}
